import React, { useLayoutEffect, useState } from 'react';
import { StyleSheet } from 'react-native';
import { AppView, Button, rem } from 'design-system';
import NavigationCloseButton from 'design-system/NavigationCloseButton';
import useAppFrameDimensions from 'hooks/useAppFrameDimensions';
import { useMarginBottom } from 'hooks/useMarginBottom';
import { goBackWithKey } from 'utils/navigationv6';
import useColors from 'hooks/useColors';
import HelpScreenButton from 'features/help/components/HelpScreenButton';
import { isIOS, isWeb } from '../../../constants';
import { CustomCategoryColorPlayground } from '../components/CustomCategoryColorPlayground';
import { useCreateCustomCategory } from '../hooks/useCreateCustomCategory';
import { readColorKeyOfRawCategory, writeColorKeyToRawCategory, } from '../utils';
const strings = {
    title: 'Choose colour',
    save: 'Save',
    continue: 'Continue',
    fallbackDisplayName: 'Category name',
    fallbackEmoji: '😀',
};
const CustomCategoryChooseColorView = ({ category, onConfirm, mustEditBeforeSave, isInIOS13Modal, isFetching, }) => {
    const btnStyle = useMarginBottom('marginBottom');
    const { paddingHorizontalStyle } = useAppFrameDimensions(isWeb, isInIOS13Modal);
    const initialColorKey = readColorKeyOfRawCategory(category) ?? 'custom';
    const [selectingColor, setSelectingColor] = useState(initialColorKey);
    return (<AppView withFrame={false} style={paddingHorizontalStyle}>
      <CustomCategoryColorPlayground category={{
            name: category.displayName || strings.fallbackDisplayName,
            emoji: category.emoji || strings.fallbackEmoji,
        }} colorKey={selectingColor} onColorKeyChanged={setSelectingColor}/>
      <Button brand isInIOS13Modal={isInIOS13Modal} title={mustEditBeforeSave ? strings.save : strings.continue} onPress={() => onConfirm(selectingColor)} isFetching={isFetching} disabled={mustEditBeforeSave === true && selectingColor === initialColorKey} style={isWeb ? undefined : [btnStyle, styles.button]} floating={isWeb}/>
    </AppView>);
};
export const CustomCategoryChooseColorScreen = ({ navigation, route }) => {
    const colors = useColors();
    useLayoutEffect(() => {
        navigation.setOptions({
            title: strings.title,
            headerTintColor: colors.elements.primary,
            headerRight: () => <HelpScreenButton />,
        });
    }, [colors.elements.primary]);
    const { category, keyBack } = route.params;
    const [isCreating, createCustomCategory] = useCreateCustomCategory(() => {
        goBackWithKey(navigation, keyBack);
    });
    return (<CustomCategoryChooseColorView category={category} onConfirm={(colorKey) => {
            createCustomCategory(writeColorKeyToRawCategory(category, colorKey));
        }} isFetching={isCreating}/>);
};
export const CustomCategoryChooseColorSheetScreen = ({ navigation, route }) => {
    const colors = useColors();
    useLayoutEffect(() => {
        navigation.setOptions({
            title: strings.title,
            headerTintColor: colors.elements.primary,
            ...(isIOS && {
                headerLeft: () => (<NavigationCloseButton onPress={() => navigation.pop()}/>),
            }),
        });
    }, [colors.elements.primary]);
    const { category } = route.params;
    return (<CustomCategoryChooseColorView category={category} mustEditBeforeSave isInIOS13Modal onConfirm={(colorKey) => {
            navigation.navigateDeprecated({
                name: 'CustomCategoryEdit',
                params: {
                    category: writeColorKeyToRawCategory(category, colorKey),
                    hasEdited: true,
                },
                merge: true,
            });
        }}/>);
};
const styles = StyleSheet.create({
    button: {
        marginHorizontal: rem(16),
        marginTop: rem(8),
    },
});
